
$(document).ready(function () {

  // When image or title is clicked
  $(document).on('click', '.bogos-bp-product-img-container, .bogos-bp-product-title', function (e) {
    e.preventDefault(); // stop redirect
    // Get the product handle from URL
    var productHandle = $(this).attr('href').split('/products/')[1];

    // Find the matching "See more" button
    var btn = $('.bogos-bp-more-btn[data-product-handle="' + productHandle + '"]');

    // Trigger its click
    btn.click();
  });

});
function equalizeCardTitleHeight() {
  var maxHeight = 0;

  // Select titles NOT inside .jewelry-look-slider
  // var $titles = $('.card__heading.h5').not(
  //   $('.jewelry-look-slider .card__heading.h5')
  // );
    var $titles = $('.card-wrapper .card__content .card__information .card__heading.h5');

  // Reset height first
  $titles.css('height', 'auto');

  // Get max height
  $titles.each(function () {
    maxHeight = Math.max(maxHeight, $(this).outerHeight());
  });

  // Apply max height
  $titles.css('height', maxHeight + 'px');
}

$(document).ready(function () {
  equalizeCardTitleHeight();
});

$(window).on('resize', function () {
  equalizeCardTitleHeight();
});


// $(document).ready(function () {

//   function setEqualTitleHeight() {
//     let maxHeight = 0;

//     const titles = $('.card-wrapper .card__content .card__heading a');

//     // Reset height first
//     titles.css('height', 'auto');

//     // Get max height
//     titles.each(function () {
//       const thisHeight = $(this).outerHeight();
//       if (thisHeight > maxHeight) {
//         maxHeight = thisHeight;
//       }
//     });

//     // Set max height to all
//     titles.css('height', maxHeight + 'px');
//   }

//   // Run on load
//   setEqualTitleHeight();

//   // Run on resize
//   $(window).on('resize', function () {
//     setEqualTitleHeight();
//   });

// });

